export default __webpack_public_path__ + "static/WF-6f8a4e37b633fdc8c3312601922b7fee.svg";